export const requirmentData = [
    {
      id: "REQ-001",
      clientName: "Client A",
      role: "Software Developer",
      maxCTC: 1200000,
      minCTC: 800000,
      numOfPositions: 5,
      status: "Active",
    },
    {
      id: "REQ-002",
      clientName: "Client B",
      role: "Software Engineer",
      maxCTC: 1000000,
      minCTC: 600000,
      numOfPositions: 3,
      status: "Inactive",
    },
    {
      id: "REQ-003",
      clientName: "Client C",
      role: "UI/UX Designer",
      maxCTC: 800000,
      minCTC: 500000,
      numOfPositions: 7,
      status: "Active",
    },
    {
      id: "REQ-004",
      clientName: "Client D",
      role: "Quality Assurance Engineer",
      maxCTC: 1500000,
      minCTC: 900000,
      numOfPositions: 10,
      status: "Active",
    },
    {
      id: "REQ-005",
      clientName: "Client E",
      role: "Frontend Developer",
      maxCTC: 1200000,
      minCTC: 800000,
      numOfPositions: 5,
      status: "Active",
    },
    {
      id: "REQ-006",
      clientName: "Client F",
      role: "Backend Developer",
      maxCTC: 1000000,
      minCTC: 600000,
      numOfPositions: 3,
      status: "Inactive",
    },
    {
      id: "REQ-007",
      clientName: "Client G",
      role: "QA Tester",
      maxCTC: 800000,
      minCTC: 500000,
      numOfPositions: 7,
      status: "Active",
    },
    {
      id: "REQ-008",
      clientName: "Client H",
      role: "BA Analyst",
      maxCTC: 1500000,
      minCTC: 900000,
      numOfPositions: 2,
      status: "Active",
    },
  ];
  
 export const candiDateData = [
    {
      id: 1,
      requirementId: "REQ-001",
      candidateName: "John Doe",
      offeredCTC: 1200000,
      discoveredOn: "2023-05-15",
      discoveredBy: "Jane Smith",
      status: "Selected",
    },
    {
      id: 2,
      requirementId: "REQ-002",
      candidateName: "Jane Doe",
      offeredCTC: 900000,
      discoveredOn: "2023-05-20",
      discoveredBy: "John Smith",
      status: "Dropped",
    },
    {
      id: 3,
      requirementId: "REQ-001",
      candidateName: "Alice Johnson",
      offeredCTC: 1500000,
      discoveredOn: "2023-05-10",
      discoveredBy: "Robert Anderson",
      status: "Joined",
    },
    {
      id: 4,
      requirementId: "REQ-004",
      candidateName: "Sarah Berry",
      offeredCTC: 1100000,
      discoveredOn: "2023-02-20",
      discoveredBy: "Cliston Anderson",
      status: "Ongoing",
    },
    {
      id: 5,
      requirementId: "REQ-003",
      candidateName: "Chris Hems",
      offeredCTC: 2000000,
      discoveredOn: "2023-01-10",
      discoveredBy: "Robert Davis",
      status: "Selected",
    },
    {
      id: 6,
      requirementId: "REQ-006",
      candidateName: "Alan Loi",
      offeredCTC: 800000,
      discoveredOn: "2023-05-10",
      discoveredBy: "Chris brews",
      status: "Joined",
    },
    {
      id: 7,
      requirementId: "REQ-007",
      candidateName: "Alice Johnson",
      offeredCTC: 1400000,
      discoveredOn: "2023-05-10",
      discoveredBy: "Robert Anderson",
      status: "Ongoing",
    },
    {
      id: 8,
      requirementId: "REQ-008",
      candidateName: "Park Risie",
      offeredCTC: 2200000,
      discoveredOn: "2023-06-17",
      discoveredBy: "Rob Joe",
      status: "Dropped",
    },
    {
      id: 9,
      requirementId: "REQ-001",
      candidateName: "Chris Mark",
      offeredCTC: 1200000,
      discoveredOn: "2023-05-21",
      discoveredBy: "Alexandar jay",
      status: "Selected",
    },
    {
      id: 10,
      requirementId: "REQ-008",
      candidateName: "Alex Mark",
      offeredCTC: 900000,
      discoveredOn: "2023-05-21",
      discoveredBy: "Mister clay",
      status: "Dropped",
    },
  ];
  
  export const reqtableHeadings = [
    "id",
    "Client Name",
    "role",
    "max CTC",
    "min CTC",
    "no. of position",
    "Status",
  ];
  
  export const candidatetableHeadings = [
    "id",
    "Requirement id",
    "Candidate Name",
    "Offered CTC",
    "Discovered On (Date)",
    "Discovered By (Name of member)",
    "Status(Selection/Ongoing/Dropped/Selected/Joined)",
  ];